import en from './en-US';
import ar from './ar-sa';
import he from './he';

const languagess = {
    ...en,
    ...ar,
    ...he,
}

 export default languagess;